import { useEffect, useState } from 'react';

import { getStorage } from '~/src/common/storage';

import { calculateIsTimeLeft } from './calculateIsTimeLeft';
import { calculateLastNHoursOfferUntil } from './calculateLastNHoursOfferUntil';
import { LAST_N_HOURS_TIMER_START } from './constants';
import { useCountdownTimer } from './useCountdownTimer';

const storage = getStorage();

function getOfferUntilAndUpdateStorage({
  offsetHours,
  lastStartDateStr,
}: {
  lastStartDateStr: string | null | undefined;
  offsetHours: number;
}) {
  const currentDate = new Date();
  const { offerUntil, shouldSaveCurrentTime } = calculateLastNHoursOfferUntil({
    currentDate,
    offsetHours,
    lastStartDateStr,
  });
  if (shouldSaveCurrentTime) {
    storage.setItem(LAST_N_HOURS_TIMER_START, currentDate.toISOString());
  }
  return offerUntil;
}

export function useLastNHoursCountdownTimer(lastHoursCount: number) {
  const [offerUntil, setOffetUntil] = useState<string | undefined>(() => {
    const startTime = storage.getItem(LAST_N_HOURS_TIMER_START);
    const calculatedOfferUntil = getOfferUntilAndUpdateStorage({
      offsetHours: lastHoursCount,
      lastStartDateStr: startTime,
    });

    return calculatedOfferUntil;
  });

  const { countdownTime } = useCountdownTimer({ offerUntil });

  useEffect(() => {
    if (!calculateIsTimeLeft(countdownTime)) {
      const calculatedOfferUntil = getOfferUntilAndUpdateStorage({
        offsetHours: lastHoursCount,
        lastStartDateStr: null,
      });

      setOffetUntil(calculatedOfferUntil);
    }
  }, [countdownTime, lastHoursCount]);

  return {
    isTimeLeft: true,
    timeDetails: countdownTime,
  };
}
